import DefaultCRUD from '../utils'
const resource = `/user`;

const { get, create } = DefaultCRUD(resource)

export default {
  get,
  create,
}
